module.exports = __webpack_public_path__ + "media/assets/images/correct-circle-icon-4b6981e1035e125f06d0984155aafa7c.svg";